/**
 * Whether a page's user guide starts open, remembered per page on this device.
 *
 * The rule: a page the user has never opened shows its guide open, once. After that the guide
 * is closed by default, and only an explicit open or close from the user changes it, so a page
 * someone keeps the guide open on stays open, and every other page stays out of the way.
 *
 * Plain data, no Preact, so a test can drive it with a fake storage.
 */
// v2: the first version recorded the render's own toggle as the user opening the guide, so its
// saved "open" values are not real choices and are left behind.
const KEY = (id) => `rz.guide.v2.${id}`;

/** The guide's state on load. A first visit shows it open and records it as seen (closed). */
export function guideOpenOnLoad(id, storage = globalThis.localStorage) {
  try {
    const v = storage.getItem(KEY(id));
    if (v !== null) return v === "1";
    storage.setItem(KEY(id), "0");
  } catch {
    /* private mode: every visit is a first visit */
  }
  return true;
}

/** Records the user's own open or close of a page's guide. */
export function rememberGuide(id, open, storage = globalThis.localStorage) {
  try {
    storage.setItem(KEY(id), open ? "1" : "0");
  } catch {
    /* private mode */
  }
}
